import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { RootNavigationManager } from '../../core/services/RootNavigationManager';

export const LoginRedirectUrlKey = 'login_redirect_url';
@Component({
  selector: 'brd-logout-route',
  template: '',
  styleUrls: ['./logout-route.component.scss']
})

export class LogoutRouteComponent implements OnInit {
  readonly loginRedirectUrlKey = LoginRedirectUrlKey;
  
  constructor(private oauthService: OAuthService, 
    private rootNavigationManager: RootNavigationManager,) { 
    this.oauthService.sessionChecksEnabled = true;
  }

  ngOnInit() {
    this.oauthService.logOut();
    localStorage.removeItem(this.loginRedirectUrlKey);
    this.rootNavigationManager.goHome();
  }

}



// WEBPACK FOOTER //
// ./src/app/security/components/logout-route.component.ts